import { useSelector } from "react-redux";

export function usePacienteSeguro() {

    const info = useSelector((state) => state.facturaCabeceraRedux.cabecera);
    return info;
}